import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { onSoundChange, setSoundOn, soundOn } from "@/lib/sound";
import { useI18n } from "@/i18n/I18nContext";

export const SoundToggle = () => {
  const { t } = useI18n();
  const [on, setOn] = useState(soundOn());
  useEffect(() => onSoundChange(setOn), []);
  return (
    <button type="button" onClick={() => setSoundOn(!on)} aria-label={on ? t("sound.off") : t("sound.on")} title={on ? t("sound.off") : t("sound.on")}
      data-testid="sound-toggle-btn"
      className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slate-300 transition-colors hover:text-amber-300">
      {on ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
    </button>
  );
};
